import Vue from 'vue'
import Router from 'vue-router'
//crm
import chainCustomer from '@/pages/Crm/UserManagement/chainCustomer'
import chainCustomerNew from '@/pages/Crm/UserManagement/chainCustomerNew'
import customerManagement from '@/pages/Crm/UserManagement/customerManagement'
import customerManagementNew from '@/pages/Crm/UserManagement/customerManagementNew'
import myCustomer from '@/pages/Crm/UserManagement/myCustomer'
import funnel from '@/pages/Crm/UserManagement/funnel'
import comeStat from '@/pages/Crm/UserManagement/comeStat'
import myCustomerNew from '@/pages/Crm/UserManagement/myCustomerNew'
import batchCustomer from '@/pages/Crm/UserManagement/batchCustomer'
import vipManagement from '@/pages/Crm/UserManagement/vipManagement'
import delayFollowUpRecord from '@/pages/Crm/ReturnManagement/delayFollowUpRecord'
import returnModeSetting from '@/pages/Crm/ReturnManagement/returnModeSetting'
import resultSetting from '@/pages/Crm/ReturnManagement/resultSetting'
import returnTaskSetting from '@/pages/Crm/ReturnManagement/returnTaskSetting'
import storeModeSetting from '@/pages/Crm/ReturnManagement/storeModeSetting'
import channelManagement from '@/pages/Crm/CrmSetting/channelManagement'
import channelTagManagement from '@/pages/Crm/CrmSetting/channelTagManagement'
import maternalConsultantSetting from '@/pages/Crm/CrmSetting/maternalConsultantSetting'
import groupingManagement from '@/pages/Crm/CrmSetting/groupingManagement'
import addMember from '@/commonTmp/CRM/CRM_addMember'
import departmentSetting from '@/pages/SystemSetting/System/departmentSetting'
import staffList from '@/pages/SystemSetting/System/staffList'
import roleList from '@/pages/SystemSetting/System/roleList'
import position from '@/pages/SystemSetting/System/position'
import permissions from '@/pages/SystemSetting/System/permissions'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/myCustomer',
      name: 'myCustomer',
      component: myCustomer
    },

    {
      path: '/myCustomerNew',
      name: 'myCustomerNew',
      component: myCustomerNew
    },
    {
      path: '/chainCustomer',
      name: 'chainCustomer',
      component: chainCustomer
    },
    {
      path: '/chainCustomerNew',
      name: 'chainCustomerNew',
      component: chainCustomerNew
    },
    {
      path: '/batchCustomer',
      name: 'batchCustomer',
      component: batchCustomer
    },
    {
      path: '/comeStat',
      name: 'comeStat',
      component: comeStat
    },
    {
      path: '/customerManagement',
      name: 'customerManagement',
      component: customerManagement
    },
    {
      path: '/customerManagementNew',
      name: 'customerManagementNew',
      component: customerManagementNew
    },
    {
      path: '/vipManagement',
      name: 'vipManagement',
      component: vipManagement
    },
    {
      path: '/delayFollowUpRecord',
      name: 'delayFollowUpRecord',
      component: delayFollowUpRecord
    },
    {
      path: '/returnModeSetting',
      name: 'returnModeSetting',
      component: returnModeSetting
    },,
    {
      path: '/resultSetting',
      name: 'resultSetting',
      component: resultSetting
    },
    {
      path: '/returnTaskSetting',
      name: 'returnTaskSetting',
      component: returnTaskSetting
    },
    {
      path: '/storeModeSetting',
      name: 'storeModeSetting',
      component: storeModeSetting
    },
    {
      path: '/channelManagement',
      name: 'channelManagement',
      component: channelManagement
    },
    {
      path: '/channelTagManagement',
      name: 'channelTagManagement',
      component: channelTagManagement
    },
    {
      path: '/maternalConsultantSetting',
      name: 'maternalConsultantSetting',
      component: maternalConsultantSetting
    },
    {
      path: '/groupingManagement',
      name: 'groupingManagement',
      component: groupingManagement
    },
    {
      path: '/staffList',
      name: 'staffList',
      component: staffList
    },
    {
      path: '/roleList',
      name: 'roleList',
      component: roleList
    },
    {
      path: '/position',
      name: 'position',
      component: position
    },
    {
      path: '/departmentSetting',
      name: 'departmentSetting',
      component: departmentSetting
    },
    {
      path: '/permissions',
      name: 'permissions',
      component: permissions
    },
    {
      path: '/addMember',
      name: 'addMember',
      component: addMember
    }
    , {
      path: '/funnel',
      name: 'funnel',
      component: funnel
    },
  ]
})


// WEBPACK FOOTER //
// ./src/router/router.js